// ================================================================
//  <bm-env> — one shared rendering for an environment name everywhere
//  in the app: the `dns` icon + the name. Replaces the per-name colored
//  pills, so environments read the same in every list, card and dialog.
//
//  Usage:
//    <bm-env name="env.name"></bm-env>                  <!-- neutral chip -->
//    <bm-env name="env.name" compact="true"></bm-env>   <!-- icon + text inline -->
//
//  Bindings:
//    name      ('<') the environment name — or null/undefined, which
//              renders emptyText.
//    compact   ('<') boolean — no padding/background; inherits the
//              surrounding font and color (titles, cells, option rows).
//    emptyText ('@') shown when the name is missing — defaults to '—'.
// ================================================================

angular.module('bizmetryApp').component('bmEnv', {
  bindings: {
    name: '<',
    compact: '<',
    emptyText: '@'
  },
  template: `
    <span class="bm-env" ng-class="{ 'bm-env--compact': $ctrl.compact }" title="{{ $ctrl.name || '' }}">
      <md-icon class="bm-env-icon">dns</md-icon>
      <span class="bm-env-name">{{ $ctrl.name || $ctrl.emptyText || '—' }}</span>
    </span>
  `
});
